import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-plan-summaries',
  templateUrl: './plan-summaries.component.html',
  styleUrls: ['./plan-summaries.component.scss']
})
export class PlanSummariesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
